// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');

//@ constants
const {
    E_CARD_PRODUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID
} = require('constants/hiringProductInformation');
const { GC } = require('constants/flagBasedFeatures');

class hireCardECardStep1 extends React.Component {
    componentDidMount() {
        const { requestPDFMerge, contracts } = this.props;
        const pdfurls = contracts && contracts.get ? contracts.get('prestacion_servicios_fisicas', '') : '';

        const product = {
            id: E_CARD_PRODUCT_ALIAS.toUpperCase()
        };
        requestPDFMerge([{ 'url': pdfurls }], [product]);
    }

    render() {
        const { hireCmsKey, immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <HiringProductInformation
                    productAlias={E_CARD_PRODUCT_ALIAS}
                    productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                />
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-ecard__step-one">
                    <FormattedText
                        className="hire-card-ecard__step-title"
                        value="hireCardECard-step1Title"
                    />
                    <HireInformation
                        hireCmsKey={hireCmsKey}
                        immHireInformation={immHireInformation}
                    />
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

hireCardECardStep1.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    hireCmsKey: PropTypes.string.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    contracts: PropTypes.object.isRequired
};

module.exports = hireCardECardStep1;
